import { AppContext, FILTER_PILL_FIELDS } from 'contexts/v2/app-context';
import { X } from 'lucide-react';
import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';

import { truncateText } from 'utils/text-formatter';

export function RoundedActiveFilters() {
  const {
    activeFiltersV2,
    setActiveFiltersV2,
    resetFilters,
    updateUrlWithParams,
    accountSlug,
    brandId,
    setIsFetchingJobs,
  } = useContext(AppContext);

  const hasActiveFilters = FILTER_PILL_FIELDS.some(
    key => activeFiltersV2[key].length > 0,
  );

  const removeFilter = (
    filterKey: (typeof FILTER_PILL_FIELDS)[number],
    optionKey: string,
  ) => {
    const newValue = activeFiltersV2[filterKey].filter(
      item => item.key !== optionKey,
    );

    setActiveFiltersV2(prev => ({
      ...prev,
      [filterKey]: newValue,
    }));

    if (accountSlug) {
      setIsFetchingJobs(true);
      const urlValue = newValue.map(opt => opt.key);
      updateUrlWithParams(accountSlug, brandId, filterKey, urlValue);
    }
  };

  if (!hasActiveFilters) {
    return null;
  }

  return (
    <div className="flex flex-wrap items-center gap-2">
      {FILTER_PILL_FIELDS.map(key =>
        activeFiltersV2[key].map(item => (
          <button
            key={`${key}-${item.key}`}
            type="button"
            onClick={() => removeFilter(key, item.key)}
            className="flex items-center gap-2 rounded-full bg-slate-100 px-3 py-1 text-sm hover:bg-slate-200"
          >
            <span title={item.label}>{truncateText(item.label, 50)}</span>
            <X className="h-4 w-4 text-gray-700" />
          </button>
        )),
      )}
      <button
        type="button"
        onClick={() => {
          resetFilters();
        }}
        className="text-primary-600 hover:text-primary-700 text-sm font-medium"
      >
        <FormattedMessage
          defaultMessage="Clear"
          description="Button to clear all filters to default values"
        />
      </button>
    </div>
  );
}
